/* eslint-disable @typescript-eslint/no-explicit-any */
import React from 'react'
import { UseFormRegister } from 'react-hook-form'

import { IFormField } from '~/types/form'
import { onMaskPhone } from '~/utils/forms'

import CheckInput from './check'
import Confirm from './confirm'
import Input from './input'
import Select from './select'
import Textarea from './textarea'

interface IProperties extends React.HTMLAttributes<unknown> {
  formName: string
  fieldData: IFormField
  register: UseFormRegister<any>
  error?: string
  optionalText?: string
}

const FormField: React.FC<IProperties> = ({
  fieldData,
  formName,
  register,
  error,
  optionalText,
  ...rest
}) => {
  if (fieldData.__component === 'forms.input-field') {
    if (fieldData.type === 'textarea') {
      return (
        <Textarea
          id={`${formName}-${fieldData.name}`}
          name={fieldData.name}
          label={fieldData.label}
          subLabel={fieldData.required ? undefined : optionalText}
          placeholder={fieldData.placeholder}
          register={register}
          error={error}
          required={fieldData.required}
          {...rest}
        />
      )
    }

    let options = {}
    if (fieldData.type === 'tel') {
      options = {
        onChange: (event: React.ChangeEvent<HTMLInputElement>) => {
          const value = onMaskPhone(event.target.value)
          event.target.value = value
        },
        setValueAs(value) {
          return onMaskPhone(value)
        },
      }
    }
    return (
      <Input
        id={`${formName}-${fieldData.name}`}
        name={fieldData.name}
        label={fieldData.label}
        subLabel={fieldData.required ? undefined : optionalText}
        placeholder={fieldData.placeholder}
        type={fieldData.type}
        register={register}
        error={error}
        registerOptions={options}
        required={fieldData.required}
        {...rest}
      />
    )
  }

  if (fieldData.__component === 'forms.select-field') {
    if (fieldData.type === 'radio' || fieldData.type == 'checkbox') {
      return (
        <CheckInput
          id={`${formName}-${fieldData.name}`}
          name={fieldData.name}
          label={fieldData.label}
          subLabel={fieldData.required ? undefined : optionalText}
          placeholder={fieldData.placeholder}
          register={register}
          options={fieldData.selectOptions}
          required={fieldData.required}
          error={error}
          type={fieldData.type}
          {...rest}
        />
      )
    }

    return (
      <Select
        id={`${formName}-${fieldData.name}`}
        name={fieldData.name}
        label={fieldData.label}
        subLabel={fieldData.required ? undefined : optionalText}
        placeholder={fieldData.placeholder}
        register={register}
        options={fieldData.selectOptions}
        required={fieldData.required}
        error={error}
        {...rest}
      />
    )
  }

  if (fieldData.__component === 'forms.confirm-field') {
    return (
      <Confirm
        id={`${formName}-${fieldData.name}`}
        name={fieldData.name}
        label={fieldData.label}
        register={register}
        error={error}
        {...rest}
      />
    )
  }

  if (fieldData.__component === 'forms.hidden-field') {
    return (
      <input
        id={`${formName}-${fieldData.name}`}
        type="hidden"
        {...register(fieldData.name)}
        value={fieldData.value}
        {...rest}
      />
    )
  }

  return false
}

export default FormField
